import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Constant Variables
import STUDENT_ONLY_TYPES from '../../utils/constant_variables/STUDENT_ONLY_TYPES';

// Icons
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

const FAQ_Container = ({
    nav: { 
        website,
        website_loading
    },
}) => {

    const [dropdown_1, setDropdown_1] = useState(false);
    const [dropdown_2, setDropdown_2] = useState(false);
    const [dropdown_3, setDropdown_3] = useState(false);
    const [dropdown_4, setDropdown_4] = useState(true);
    const [dropdown_5, setDropdown_5] = useState(false);
    const [dropdown_6, setDropdown_6] = useState(false);
    const [dropdown_7, setDropdown_7] = useState(false);
    const [dropdown_8, setDropdown_8] = useState(false);
    const [dropdown_9, setDropdown_9] = useState(false);
    const [dropdown_10, setDropdown_10] = useState(false);

    // Capitalize the first letter of each word
    const capitalizeWords = (inputString) => {
        return replaceHyphenWithSpace(inputString.replace(/\b\w/g, char => char.toUpperCase()));
    }

    const replaceHyphenWithSpace = (inputString) => {
        return replaceIesWithY(inputString.replace(/-/g, ' '));
    }

    const replaceIesWithY = (inputString) => {
        return removeLastS(inputString.replace(/ies\b/g, 'y'));
    }

    const removeLastS = (inputString) => {
        return inputString.replace(/s\b/g, '');
    }

    return (
        <div style={{width: '100%', boxSizing: 'border-box', flexWrap: 'wrap', display: 'flex', margin: 'auto'}}>
            <div style={{padding: '24px 0', display: 'flex', flexDirection: 'column', flex: 1}}>
                {/* FAQ category description */}
                <div style={{marginBottom: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1}}>
                    <div style={{fontSize: '28px', fontWeight: 'bold'}}>
                        FAQ
                    </div>
                </div>
                {!website && (
                    <Fragment>
                        <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                            <div onClick={() => setDropdown_4(!dropdown_4)} className='faq_dropdown_header'>
                                <div style={{marginRight: '12px', flex: 1}}>
                                    <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                        What are buy / sell groups?
                                    </div>
                                </div>
                                <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    {dropdown_4 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                            </div>
                            <div style={{height: `${dropdown_4 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                                <div style={{fontSize: '16px', lineHeight: '22px'}}>
                                    They are group chats focused on buying and selling items in niche categories or locations. You can join existing groups or create your own.
                                </div>
                            </div>
                        </div>
                        <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                            <div onClick={() => setDropdown_2(!dropdown_2)} className='faq_dropdown_header'>
                                <div style={{marginRight: '12px', flex: 1}}>
                                    <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                        Can I create my own group?
                                    </div>
                                </div>
                                <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    {dropdown_2 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                            </div>
                            <div style={{height: `${dropdown_2 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                                <div style={{fontSize: '16px', lineHeight: '22px'}}>
                                    Yes! If you don't see a group for your specific niche, you can create one. Just go to the Groups page and click "Create Group".
                                </div>
                            </div>
                        </div>
                        <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                            <div onClick={() => setDropdown_1(!dropdown_1)} className='faq_dropdown_header'>
                                <div style={{marginRight: '12px', flex: 1}}>
                                    <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                        How do I join a group?
                                    </div>
                                </div>
                                <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    {dropdown_1 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                            </div>
                            <div style={{height: `${dropdown_1 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                                <div style={{fontSize: '16px', lineHeight: '22px'}}>
                                    Click "Follow" to join a group and stay up to date on new posts. It's like following a creator on social media. 
                                </div>
                            </div>
                        </div>
                        <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                            <div onClick={() => setDropdown_3(!dropdown_3)} className='faq_dropdown_header'>
                                <div style={{marginRight: '12px', flex: 1}}>
                                    <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                        Is this platform free to use?
                                    </div>
                                </div>
                                <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    {dropdown_3 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                            </div>
                            <div style={{height: `${dropdown_3 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                                <div style={{fontSize: '16px', lineHeight: '22px'}}>
                                    Yes. Anyone can join, create groups, and post for free.
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
                {(website && STUDENT_ONLY_TYPES.includes(website?.privacy?.toLowerCase())) && (
                    <Fragment>
                        <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                            <div onClick={() => setDropdown_9(!dropdown_9)} className='faq_dropdown_header'>
                                <div style={{marginRight: '12px', flex: 1}}>
                                    <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                        Are we affiliated with your school?
                                    </div>
                                </div>
                                <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    {dropdown_9 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                            </div>
                            <div style={{height: `${dropdown_9 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                                <div style={{fontSize: '16px', lineHeight: '22px'}}>
                                    No! We aren't associated with your school.
                                </div>
                            </div>
                        </div>
                        <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                            <div onClick={() => setDropdown_10(!dropdown_10)} className='faq_dropdown_header'>
                                <div style={{marginRight: '12px', flex: 1}}>
                                    <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                        I'm a student! How do I join? 
                                    </div>
                                </div>
                                <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    {dropdown_10 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                            </div>
                            <div style={{height: `${dropdown_10 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                                <div style={{fontSize: '16px', lineHeight: '22px'}}>
                                    All you need is a .edu school email to join. Simply log in and verify your .edu email to join the community.
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
                <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                    <div onClick={() => setDropdown_7(!dropdown_7)} className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                How do I sell an item?
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_7 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_7 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                        <div style={{fontSize: '16px', lineHeight: '22px'}}>
                            Write a post about what you're selling and how much it costs. Add an optional photo or video. Then post it into a relevant group.
                        </div>
                    </div>
                </div>
                <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                    <div onClick={() => setDropdown_6(!dropdown_6)} className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                How do I buy an item?
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_6 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_6 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                        <div style={{fontSize: '16px', lineHeight: '22px'}}>
                            You can comment on a post or send a private message to the seller to negotiate and meet.
                        </div>
                    </div>
                </div>
                <div style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid #e6ecf0'}}>
                    <div onClick={() => setDropdown_8(!dropdown_8)} className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '22px', fontWeight: 'bold', overflow: 'hidden'}}>
                                What about Scams?
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_8 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_8 ? 'fit-content' : '0'}`, overflow: 'hidden', margin: '10px 16px 20px'}}>
                        <div style={{fontSize: '16px', lineHeight: '22px'}}>
                            We provide the platform for communication, but always recommend meeting in a safe, public place (like a police station) for safety.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

// Prop types for the component
FAQ_Container.propTypes = {

    // Prop type validation for function to toggle the profile modal
    nav: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    nav: state.nav
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component 
})(FAQ_Container);